import { Building2 } from 'lucide-react';
import type { Office } from '@odd/domain';
import { Select } from './ui';
import { UserMenu, type AppView } from './UserMenu';
import './AppHeader.css';

interface AppHeaderProps {
  offices: Office[];
  officeId: string | null;
  setOfficeId: (id: string) => void;
  onHome: () => void;
  email?: string;
  onLogout?: () => void;
  onRules?: () => void;
  view: AppView;
  onView?: (view: AppView) => void;
}

export function AppHeader({
  offices,
  officeId,
  setOfficeId,
  onHome,
  email,
  onLogout,
  onRules,
  view,
  onView,
}: AppHeaderProps) {
  const office = offices.find((item) => item.id === officeId);
  return (
    <header className="app-header">
      <div className="app-header-inner">
        <button className="app-header-brand" aria-label="Ir a la reunión operativa" onClick={onHome}>
          <span className="app-header-logo">
            <img src="/brand/eleva-logo.svg" alt="Eleva" className="logo-light" />
            <img src="/brand/eleva-logo-white.svg" alt="Eleva" className="logo-dark" />
          </span>
          <span className="app-header-product">
            Operativa
            <br />
            semanal
          </span>
        </button>

        {offices.length > 0 && (
          <div className="app-header-office">
            <Building2 className="app-header-office-icon" size={19} strokeWidth={1.5} aria-hidden="true" />
            <div className="app-header-office-content">
              <span className="app-header-office-label">Oficina actual</span>
              {offices.length > 1 ? (
                <Select
                  label="Oficina"
                  className="app-office-picker"
                  value={officeId ?? ''}
                  onChange={setOfficeId}
                  placeholder="Elegir oficina…"
                  searchPlaceholder="Buscar oficina…"
                  options={offices.map((item) => ({ value: item.id, label: item.name }))}
                />
              ) : (
                <span className="app-header-office-name">{office?.name ?? offices[0]!.name}</span>
              )}
            </div>
          </div>
        )}

        <div className="app-header-actions">
          {view === 'admin' && onView && <span className="app-header-view-label">Administración</span>}
          <UserMenu email={email} view={view} onView={onView} onRules={onRules} onLogout={onLogout} />
        </div>
      </div>
    </header>
  );
}
